import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import withData from 'components/withData';

import { UploadVendorStateContext } from '.';

class Provider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		response: PropTypes.shape({
			loading: PropTypes.bool,
			data: PropTypes.any,
			refetch: PropTypes.func,
		}),
	};

	state = {
		vendorStatus: null,
		vendorPreviousStatus: null,
		isVendorStateFetching: false,
	};

	componentWillReceiveProps(nextProps) {
		const { response } = nextProps;

		if (response.success && !this.props.response.success) {
			this.setState({
				vendorStatus: response.data,
			});
		}
	}

	handleRefetch = forceChildrenUpdate => {
		this.setState({ isVendorStateFetching: true });
		if (forceChildrenUpdate) {
			this.setState({
				vendorStatus: null,
				vendorPreviousStatus: this.state.vendorStatus,
			});
		}
		this.props.response.refetch();
		this.setState({ isVendorStateFetching: false });
	};

	render() {
		return (
			<UploadVendorStateContext.Provider
				value={{
					...this.state,
					refetchVendor: this.handleRefetch,
				}}
			>
				{this.state.vendorStatus || this.props.response.success
					? this.props.children
					: null}
			</UploadVendorStateContext.Provider>
		);
	}
}

export const UploadVendorStateContextProvider = withRouter(
	withData('/data-classification/newstate')(Provider)
);
